<template>
  <b-container>
    <img alt="TTT Calculator Logo" src="../assets/logo.png" />

    <b-row>
      <b-col>
        <h2 class="text-left mt-3">Traitor:</h2>
        <b-input-group prepend="ttt_traitor_pct">
          <b-form-input
            v-model="ttt_traitor_pct"
            type="number"
            min="0.00"
            max="1"
            step=".01"
            @input="SelectRoles"
          ></b-form-input>
        </b-input-group>

        <b-input-group prepend="ttt_traitor_max" class="mt-3">
          <b-form-input
            v-model="ttt_traitor_max"
            type="number"
            min="1"
            step="1"
            @input="SelectRoles"
          ></b-form-input>
        </b-input-group>

        <h2 class="text-left mt-3">Detective:</h2>
        <b-input-group prepend="ttt_detective_pct">
          <b-form-input
            v-model="ttt_detective_pct"
            type="number"
            min="0.00"
            max="1"
            step=".01"
            @input="SelectRoles"
          ></b-form-input>
        </b-input-group>

        <b-input-group prepend="ttt_detective_max" class="mt-3">
          <b-form-input
            v-model="ttt_detective_max"
            type="number"
            min="1"
            step="1"
            @input="SelectRoles"
          ></b-form-input>
        </b-input-group>

        <b-input-group prepend="ttt_detective_min_players" class="mt-3">
          <b-form-input
            v-model="ttt_detective_min_players"
            type="number"
            min="0"
            step="1"
            @input="SelectRoles"
          ></b-form-input>
        </b-input-group>
      </b-col>

      <b-col>
        <b-input-group class="mb-2">
          <b-input-group-prepend>
            <img
              alt="Icon Players"
              src="../assets/icon_disguise.png"
              height="48"
              class="mr-2"
            />
          </b-input-group-prepend>
          <b-form-input
            v-model="players_count"
            type="number"
            min="1"
            step="1"
            size="lg"
            @input="SelectRoles"
          ></b-form-input>
        </b-input-group>

        <b-row>
          <b-col cols="1" class="mr-2">
            <img alt="Icon Innocent" src="../assets/icon_inno.png" height="48"
          /></b-col>
          <b-col class="text-left align-middle">
            <h1>Innocents: {{ inno_count }}</h1>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="1" class="mr-2">
            <img alt="Icon Traitor" src="../assets/icon_traitor.png" height="48"
          /></b-col>
          <b-col class="text-left align-middle">
            <h1>Traitors: {{ traitor_count }}</h1>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="1" class="mr-2">
            <img alt="Icon Detective" src="../assets/icon_det.png" height="48"
          /></b-col>
          <b-col class="text-left align-middle">
            <h1>Detectives: {{ det_count }}</h1>
          </b-col>
        </b-row>

        <b-form-textarea
          id="textarea"
          v-model="cfg_generated"
          placeholder="Enter something..."
          rows="5"
          max-rows="5"
          readonly
          no-resize
        ></b-form-textarea>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col>
        <h2>Players Table</h2>
        <b-form-input
          v-model="table_players"
          type="number"
          min="1"
          max="255"
          step="1"
          @input="SelectRoles"
          v-b-tooltip.hover.right
          title="Maximum 255 Players"
        ></b-form-input>
        <b-table
          striped
          hover
          :items="tblPlayers"
          primary-key="players"
        ></b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",

  data() {
    return {
      ttt_traitor_pct: 0.25,
      ttt_traitor_max: 32,
      ttt_detective_pct: 0.13,
      ttt_detective_max: 32,
      ttt_detective_min_players: 10,
      traitor_count: 0,
      det_count: 0,
      inno_count: 0,
      players_count: 6,
      table_players: 64,
      cfg_generated: "",
      eggStep: 0,
      eggActivated: false,
      tblPlayers: [
        {
          players: 1,
          innocents: 1,
          traitors: 1,
          detectives: 0,
          _cellVariants: {
            innocents: "success",
            traitors: "danger",
            detectives: "primary"
          }
        },
        {
          players: 2,
          innocents: 1,
          traitors: 1,
          detectives: 0,
          _cellVariants: {
            innocents: "success",
            traitors: "danger",
            detectives: "primary"
          }
        },
        {
          players: 3,
          innocents: 1,
          traitors: 1,
          detectives: 0,
          _cellVariants: {
            innocents: "success",
            traitors: "danger",
            detectives: "primary"
          }
        },
        {
          players: 4,
          innocents: 1,
          traitors: 1,
          detectives: 1,
          _cellVariants: {
            innocents: "success",
            traitors: "danger",
            detectives: "primary"
          }
        }
      ],
      loading: true
    };
  },

  created() {
    this.onKeyDown = this.onKeyDown.bind(this);
    document.addEventListener("keydown", this.onKeyDown);
  },
  destroyed() {
    document.removeEventListener("keydown", this.onKeyDown);
  },

  methods: {
    Clamp(input, min, max) {
      return Math.min(Math.max(input, min), max);
    },
    GetTraitorCount(ply_count) {
      //get number of traitors: pct of players rounded down
      var traitor_count = Math.floor(ply_count * this.ttt_traitor_pct);
      //make sure there is at least 1 traitor
      traitor_count = this.Clamp(traitor_count, 1, this.ttt_traitor_max);
      return traitor_count;
    },
    GetDetectiveCount(ply_count) {
      if (ply_count < this.ttt_detective_min_players) return 0;

      var det_count = Math.floor(ply_count * this.ttt_detective_pct);
      //limit to a max
      det_count = this.Clamp(det_count, 1, this.ttt_detective_max);

      return det_count;
    },
    SelectRoles() {
      var calcRoles = this.CalculateRoles(parseInt(this.players_count));

      this.traitor_count = calcRoles.traitor_count;
      this.det_count = calcRoles.det_count;
      this.inno_count = calcRoles.inno_count;

      this.cfg_generated =
        `ttt_traitor_pct ` +
        this.ttt_traitor_pct +
        `\nttt_traitor_max ` +
        this.ttt_traitor_max +
        `\nttt_detective_pct ` +
        this.ttt_detective_pct +
        `\nttt_detective_max ` +
        this.ttt_detective_max +
        `\nttt_detective_min_players ` +
        this.ttt_detective_min_players;

      this.tblPlayers.length = 0;
      this.table_players = this.Clamp(this.table_players, 1, 255);
      for (var i = 1; i <= this.table_players; i++) {
        var tblRolesCalc = this.CalculateRoles(i);
        var insert = {
          players: i,
          innocents: tblRolesCalc.inno_count,
          traitors: tblRolesCalc.traitor_count,
          detectives: tblRolesCalc.det_count,
          _cellVariants: {
            innocents: "success",
            traitors: "danger",
            detectives: "primary"
          }
        };
        this.tblPlayers.push(insert);
      }
    },
    CalculateRoles(players_count) {
      var inno_count = players_count;
      var traitor_count = this.GetTraitorCount(players_count);
      var det_count = this.GetDetectiveCount(players_count);

      inno_count -= traitor_count;

      if (det_count >= inno_count) {
        det_count = inno_count;
        inno_count = 0;
      } else {
        inno_count -= det_count;
      }

      var obj = {
        inno_count: inno_count,
        traitor_count: traitor_count,
        det_count: det_count
      };
      return obj;
    },
    easterEgg() {
      this.eggActivated = !this.eggActivated;
      if (this.eggActivated == true) {
        var el =
          '<iframe style="display: none;" width="560" height="315" src="https://www.youtube.com/embed/Nx_Uorw_6Sg?controls=0&amp;start=65&amp;autoplay=1"" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
        document.getElementById("test").innerHTML = el;
        document.getElementById("app").style.backgroundImage =
          "url(" + require("@/assets/easteregg.jpg") + ")";
        document.getElementById("app").style.backgroundRepeat = "no-repeat";
        document.getElementById("app").style.backgroundSize = "cover";
        document.getElementById("app").style.backgroundAttachment = "fixed";
        document.getElementById("app").style.backgroundPosition = "center";
      } else {
        document.getElementById("test").innerHTML = "";
        document.getElementById("app").style.backgroundImage = "none";
      }
    },
    onKeyDown(e) {
      var magic_word = [65, 78, 73, 77, 69];
      if (e.keyCode == magic_word[this.eggStep]) {
        this.eggStep++;

        if (this.eggStep == 5) {
          this.eggStep = 0;
          this.easterEgg();
        }
      } else {
        this.eggStep = 0;
      }
    }
  },

  mounted() {
    this.SelectRoles();
  }
};
</script>
